<template>
  <div class="wrapper-login">
    <div class="top_header_logo">
      <img
        src="/assets/green4t_logo_white.png"
        alt="GREEN4T"
      >
    </div>
    <div class="top_header_logo" />

    <div class="login">
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <input
            v-model="username"
            type="text"
            name="username"
            placeholder="usuário"
            class="form-control"
            :class="{ 'is-invalid': submitted && !username }"
          >
          <!-- <div v-show="submitted && !username" class="invalid-feedback">Username is required</div> -->
        </div>
        <div class="form-group">
          <!-- <label htmlFor="password">Password</label> -->
          <input
            v-model="password"
            type="password"
            name="password"
            placeholder="senha"
            class="form-control"
            :class="{ 'is-invalid': submitted && !password }"
          >
          <!-- <div v-show="submitted && !password" class="invalid-feedback">Password is required</div> -->
        </div>
        <div class="form-group">
          <input
            type="submit"
            value="Entrar"
          >
        </div>
        <div
          v-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>

        <div class="form-group">
          <br>
          <p class="text-center">
            <a
              id="forget"
              style="color: Gray"
              href="https://sgi.green4t.com/front/lostpassword.php?lostpassword=1"
            >Esqueceu a senha?</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<style src="./login.css" />

<script>
import axios from "axios";

import authService from "../../_services/auth.service";
import { getUserSession } from "../../_services/localstorage";

export default {
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      returnUrl: "",
      error: "",
    };
  },
  created() {
    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || "/";

    const user = getUserSession();
    if (user) {
      this.$router.push(this.returnUrl);
    }
  },
  methods: {
    async handleSubmit() {
      this.submitted = true;
      const { username, password } = this;
      // stop here if form is invalid
      if (!(username && password)) {
        return;
      }
      this.$progress.start();

      try {
        await authService.login(username, password);
        this.$router.push(this.returnUrl);
      } catch (e) {

        if (axios.isAxiosError(e)) {
          this.error = this.parseGlpiErrorMessage(e.response.data.message);
        } else {
          this.error = "Erro ao fazer login!";
          console.error(e);
        }

        this.$progress.stop();
      }
    },
    parseGlpiErrorMessage(message) {
      return message
        .replace("GLPI Error:", "")
        .replace("(ERROR_GLPI_LOGIN)", "")
        .trim();
    },
  },
};
</script>
